// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_56-0";
export var eligibilityCardNotEligible = "_56-1";